// eslint-disable-next-line import/no-cycle
import {
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  FieldsGroup,
  BackgroundImageOptionTypeEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import getBackgroundImageFieldConfig from '@/components/template-builder/config/fields/background-image-config';
// eslint-disable-next-line import/no-cycle
import {
  getCssPropertyByName,
  getClassByName, isMediaDisplayAlreadyRestricted,
  getBackgroundImageValue,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import {
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
  setBackgroundImage,
  setBackgroundImageProperty,
} from '@/components/template-builder/setters';
import {getTemplateIframeDocument} from "@/components/template-builder/utils/helpers";
import {HIDE_MOBILE_ATTRIBUTE} from "@/components/template-builder/utils/constants";

const getWidgetCommonStylesGroup = (paddingSelector = '{SELECTOR}'): FieldsGroup => ({
  type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
  label: 'templateBuilder.configs.widgetCommonStyles',
  selector: 'body #spm_body #{ID}',
  items: [
    {
      label: 'templateBuilder.fields.backgroundColor',
      selector: '{SELECTOR}',
      properties: [{
        name: 'background',
        getter: getCssPropertyByName,
        setters: [setCssProperty],
      }],
      ...getColorFieldConfig(undefined, false, true),
    },
    {
      label: 'templateBuilder.fields.backgroundImage',
      selector: '{SELECTOR}',
      properties: [
        { name: 'background-image', getter: getBackgroundImageValue, setters: [setBackgroundImage] },
        { name: 'background-size', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
        { name: 'background-position-x', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
        { name: 'background-position-y', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
        { name: 'background-repeat', getter: getCssPropertyByName, setters: [setBackgroundImageProperty] },
      ],
      linkedItem: 'templateBuilder.fields.backgroundColor',
      ...getBackgroundImageFieldConfig(BackgroundImageOptionTypeEnum.FULL),
    },
    {
      label: 'templateBuilder.fields.internalMargins',
      selector: paddingSelector,
      properties: [
        { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
        { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
        { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
        { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
      ],
      componentName: ComponentNameEnum.SPACES,
      options: {
        ...getVerticalSpacesFieldConfig('padding').options,
        ...getHorizontalSpacesFieldConfig('padding').options,
      },
    },
    {
      label: 'templateBuilder.fields.mediaDisplay',
      selector: '{SELECTOR}',
      properties: [{ name: 'show-for-', getter: getClassByName, setters: [setMediaDisplay] }],
      disableHandler: (selector: string) => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true' || isMediaDisplayAlreadyRestricted(selector),
      disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
      ...mediaDisplayFieldConfig,
    },
  ],
});

export default getWidgetCommonStylesGroup;
